import { memo } from 'react'
import { createSearchParams, useNavigate } from 'react-router-dom'

import { useAppDispatch } from '@store/hooks'
import CloseSvg from '@svgs/close.svg'
import EditTicket from '@svgs/editTicket.svg'
import { ITicket } from '@appTypes/global'
import { fireFinishTicket } from '@store/features/ticket/ticket.actions'
import { setPopUpData } from '@store/features/general/general.slice'
import { saveTicketInStorage } from '@pages/CreateTicket/book-ticket'
import { getDateFromFirstGroup } from '@utils/time'
import { convertGroupsData } from '@utils/general'
import { PAGE_ROUTES_PRIVATE } from '@appTypes/enums/pages'
import { ActionButton, CardActionsRow } from './styled'

type Props = {
  page: 'OpenTickets' | 'TicketsHistory'
  ticket: ITicket
  showEdit: boolean
  showFinish: boolean
}

const TicketCardActions = ({ page, ticket, showEdit, showFinish }: Props) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  if (!showEdit && !showFinish) {
    return null
  }

  const handleEdit = () => {
    const dateFromFirstGroup = getDateFromFirstGroup(ticket.groups)
    const convertedGroups = convertGroupsData(ticket.groups)

    saveTicketInStorage({
      courses: ticket?.ticketCourses?.map(({ course }) => course) || [],
      groups: convertedGroups,
      comment: ticket.comment,
      date: {
        date: dateFromFirstGroup.toISOString(),
        interval: ticket.availability
      }
    })

    navigate({
      pathname: PAGE_ROUTES_PRIVATE.CREATE_TICKET,
      search: createSearchParams({ ticketId: ticket.id }).toString()
    })
  }

  const handleFinish = () => {
    dispatch(fireFinishTicket({ id: ticket.id }))
      .then(() => {
        dispatch(setPopUpData({ status: true, popUpId: ticket.id }))
      })
      .catch(console.log)
  }

  return (
    <CardActionsRow page={page}>
      {showEdit ? (
        <ActionButton type='button' aria-label='Edit ticket' onClick={handleEdit}>
          <img src={EditTicket} width={15} height={15} alt='' />
        </ActionButton>
      ) : null}
      {showFinish ? (
        <ActionButton type='button' aria-label='Close ticket' onClick={handleFinish}>
          <img src={CloseSvg} width={12} height={12} alt='' />
        </ActionButton>
      ) : null}
    </CardActionsRow>
  )
}

export default memo(TicketCardActions)
